/**
 * Australian Qualifications Framework — 10 levels.
 * Source: https://www.aqf.edu.au
 */

export type AqfLevel =
  | 'level_1'
  | 'level_2'
  | 'level_3'
  | 'level_4'
  | 'level_5'
  | 'level_6'
  | 'level_7'
  | 'level_8'
  | 'level_9'
  | 'level_10';

export const AQF_LEVELS: readonly AqfLevel[] = [
  'level_1',
  'level_2',
  'level_3',
  'level_4',
  'level_5',
  'level_6',
  'level_7',
  'level_8',
  'level_9',
  'level_10',
] as const;

export const AQF_LEVEL_LABELS: Record<AqfLevel, string> = {
  level_1: 'AQF Level 1 — Certificate I',
  level_2: 'AQF Level 2 — Certificate II',
  level_3: 'AQF Level 3 — Certificate III',
  level_4: 'AQF Level 4 — Certificate IV',
  level_5: 'AQF Level 5 — Diploma',
  level_6: 'AQF Level 6 — Advanced Diploma / Associate Degree',
  level_7: 'AQF Level 7 — Bachelor Degree',
  level_8: 'AQF Level 8 — Bachelor Honours / Graduate Certificate / Graduate Diploma',
  level_9: 'AQF Level 9 — Masters Degree',
  level_10: 'AQF Level 10 — Doctoral Degree',
};
